import { uuid8 } from "@/util/common/randomId";

function toArray(args) {
    let params = [];
    for (let i = 0, len = args.length; i < len; i++) {
        params.push(args[i]);
    }
    return params;
}

/**
 * 主题
 */
export class Subject {

    observers = [];

    /**
     * 订阅
     * @param observer 观察者
     */
    subscribe(observer) {
        if (observer.id == null) {
            observer.id = uuid8();
        }
        this.observers.push(observer);
        return observer.id;
    }

    /**
     * 取消订阅
     * @param id 观察者标识
     */
    unsubscribe(id) {
        const { observers } = this;
        const len = observers.length;
        let index = -1;
        for (let i = 0; i < len; i++) {
            if (observers[i].id === id) {
                index = i;
            }
        }
        if (index !== -1) {
            observers.splice(index, 1);
        }
    }

    /**
     * 触发
     */
    next() {
        const { observers } = this;
        const len = observers.length;
        for (let i = 0; i < len; i++) {
            observers[i].next.apply(this, arguments);
        }
    }

}

/**
 * 事件总线
 */
export class EventBus {

    subjects = {};

    bind(key, observer) {
        let subject = this.getSubject(key);
        if (subject == null) {
            subject = new Subject();
            this.subjects[key] = subject;
        }
        subject.subscribe(observer);
    }

    unbind(key, observer) {
        if (observer == null) {
            this.subjects[key] = undefined;
        } else {
            let subject = this.getSubject(key);
            if (subject != null) {
                subject.unsubscribe(observer);
            }
        }
    }

    trigger(key) {
        let subject = this.getSubject(key);
        if (subject != null) {
            let params = toArray(arguments);
            subject.next.apply(subject, params.slice(1));
        }
    }

    getSubject(key) {
        if (this.subjects.hasOwnProperty(key)) {
            return this.subjects[key];
        }
        return null;
    }
}

const eventBus = new EventBus();

export default eventBus;
